import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { SessionService } from '../../services/session/session.service';
import { MatButtonModule } from '@angular/material/button';

/**
 * ExtendSessionDialogComponent opens up a dialog to prompt the user on whether or
 * not they'd like to extend their session
 */
@Component({
  selector: 'app-extend-session-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './extend-session-dialog.component.html',
  styleUrl: './extend-session-dialog.component.scss'
})
export class ExtendSessionDialogComponent {
  /** Session time countdown */
  public sessionTimeRemaining: string = "";

  /**
   * Default constructor initializes the component with a dialog ref
   */
  constructor(
    public dialogRef: MatDialogRef<ExtendSessionDialogComponent>,
    private _authService: AuthService,
    private _router: Router,
    private _sessionService: SessionService,
  ) {
    // Subscribe to time changes
    this._sessionService.clock$.subscribe(
      (timestamp: string) => {
        this.sessionTimeRemaining = timestamp;

        // If the time is up, close the dialog
        if (timestamp === "0:00") {
          this.dialogRef.close();
        }
      }
    );
  }

  /**
   * Log the user out and navigate them to the login screen
   */
  public logout() {
    this._authService.logout();
    this.dialogRef.close();
  }

  /**
   * Extend the user's session
   */
  public extendSession() {
    this._sessionService.refresh();
    this.dialogRef.close();
  }
}
